import { useEffect, useMemo } from 'react'

export const useMountAbortController = () => {
  const controller = useMemo(() => new AbortController(), [])

  useEffect(() => {
    return () => {
      controller.abort()
    }
  }, [controller])

  return controller
}
